import cronParser from 'cron-parser';

export function getNextIteration(cronExpression) {
    if (!cronExpression) {
        return;
    }

    const interval = cronParser.parseExpression(
        convertCronExpression(cronExpression)
    );
    return interval.next().toISOString();
}

function convertCronExpression(value) {
    const expressions = {
        EVERY_1MINUTE: '*/1 * * * *',
        EVERY_10MINUTES: '*/10 * * * *',
        EVERY_2HOURS: '*/2 * * * *',
        EVERY_3HOURS: '*/3 * * * *',
        EVERY_4HOURS: '*/4 * * * *',
        EVERY_6HOURS: '*/6 * * * *',
        EVERY_8HOURS: '*/8 * * * *',
        EVERY_12HOURS: '0 */12 * * *',
    };

    return expressions[value] || value;
}

